<!-- auction -->
<template>
 <div class="auction-box">
    <Row>
      <Col span="24">
        <div class="pad-style"><strong>申请年份 (入学年份) :</strong>{{actionInfo.applyYear}}</div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>本科学校&nbsp;专业:</strong>{{actionInfo.course}}</div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>欲申请专业:</strong>{{actionInfo.targetCourse}}</div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>欲申请学位:</strong>{{actionInfo.studyAbroadType}}</div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>欲申请国家/地区:</strong>{{actionInfo.targetCountry}}</div>
      </Col>
       <Col span="24">
        <div class="pad-style"><strong>竞单时薪 :</strong>{{actionInfo.wage}}</div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>特殊需求:</strong>{{actionInfo.otherIntended}}</div>
      </Col>
      <!-- <Col span="24">
        <div class="pad-style"><strong>预计辅导时长:(具体时长参见MSP)</strong></div>
      </Col> -->
      <Col span="24">
        <div class="pad-style"><strong>预计视频辅导时长:(具体时长参见MSP)</strong><span v-if="zoomTime">{{zoomTime}}分钟</span></div>
      </Col>
      <Col span="24">
        <div class="pad-style"><strong>预计文书修改时长:(具体时长参见MSP)</strong><span v-if="editTime">{{editTime}}分钟</span></div>
      </Col>
    </Row>
    <Form ref="formValidate"
          :model="formValidate"
          :rules="ruleForm"
          >
      <FormItem label="自荐原因"
                prop="reason">
        <Input v-model.trim="formValidate.reason"
               type="textarea"></Input>
      </FormItem>
    </Form>
    <div class="intro-btn">
      <Button class="zlr-btn-primary"
              @click="handleSub('formValidate')">提交</Button>
    </div>
 </div>
</template>
<script>
import { mentorSaveReason, getAuctionInfo } from '@/api/mentor'
export default {
  name: '',
  components: {},
  data () {
    return {
      formValidate: {},
      ruleForm: {
        reason: [
          { required: true, message: '姓名不能为空', trigger: 'blur' }
        ]
      },
      id: '',
      actionInfo: {},
      zoomTime: '',
      editTime: ''
    }
  },
  computed: {},
  mounted () {
    this.getAuctionInfo()
  },
  methods: {
    handleSub (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          mentorSaveReason({ id: this.$route.params.id, reason: this.formValidate.reason }).then(res => {
            if (res.code === 0) {
              this.$Message.success('提交成功!')
            }
          })
        } else {
          this.$Message.error('自荐原因不能为空')
        }
      })
    },
    getAuctionInfo () {
      getAuctionInfo({ id: this.$route.params.id }).then(res => {
        if (res.code === 0) {
          console.log(res)
          this.actionInfo = res.data.info
          this.editTime = res.data.editTime
          this.zoomTime = res.data.zoomTime
          if (this.actionInfo.targetCountry) {
            this.actionInfo.targetCountry = this.actionInfo.targetCountry.replace(',Other', '')
            this.actionInfo.targetCountry = this.actionInfo.targetCountry.replace('Other,', '')
            this.actionInfo.targetCountry = this.actionInfo.targetCountry.replace('[]', '')
          }
        }
      })
    }
  }
}
</script>
<style lang='less' scoped>
.auction-box {
  width:1280px;
  margin:40px auto 0;
  .pad-style {
    padding-bottom:10px;
    strong {
      padding-right:10px;
    }
  }
  /deep/ .ivu-form .ivu-form-item-label {
    font-weight: bold;
  }
}
</style>
